// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"b4-z","colorTextValue":"c4-z","swatches":"d4-z","collapseLink":"e4-z","isCollapsed":"f4-z","dropdown":"g4-z","disabled":"h4-z"};